import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=c555cfec&scoped=true"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c555cfec",
  null
  
)

export default component.exports